<template>
  <div class="basic-manners-card">
    <va-card title="Basic Manners">
      <basic-manners-classes />
      <h2 class="curriculum">
        Class curriculum
      </h2>
      <span class="class-description">
        In this 6 week class, you will learn how to teach your dog skills for calm, polite behaviors inside the house and outside.
        Your dog will learn hand targeting, sit, down, leave it, stay, go to place, drop it, loose leash walking, coming when called,
        polite greetings, and more!
      </span>
      <va-accordion>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 1 - The Foundations
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 1 we will cover:
              <ol>
                <li>Introducing the marker</li>
                <li>Eye contact</li>
                <li>Name game</li>
                <li>Hand targeting</li>
                <li>Sit</li>
                <li>Down</li>
                <li>Dog body language</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 2 - Impulse Control
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 2 we will cover:
              <ol>
                <li>Adding "Focus" cue to eye contact</li>
                <li>When to add in a cue</li>
                <li>Adding cues to sit and down</li>
                <li>Hand target with distance</li>
                <li>Leave it</li>
                <li>Stay</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 3 - More Impulse Control
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 3 we will cover:
              <ol>
                <li>Leave it in more situations</li>
                <li>Coming when called</li>
                <li>Advanced Stay</li>
                <li>Mat work</li>
                <li>Relaxation Protocol</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 4 - Skills for the Outside World
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 4 we will cover:
              <ol>
                <li>Advanced coming when called</li>
                <li>Go to place</li>
                <li>Take it/Drop it</li>
                <li>Loose leash walking</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 5 - Polite Greetings
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 5 we will cover:
              <ol>
                <li>Advanced go to place</li>
                <li>Advanced take it/drop it</li>
                <li>No jumping</li>
                <li>Saying hi</li>
                <li>Advanced loose leash walking</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 6 - Show Off Your New Skills
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 6 we will cover:
              <ol>
                <li>How to troubleshoot problem behaviors</li>
                <li>Show off all of the new skills learned</li>
                <li>Graduation!</li>
              </ol>
            </div>
          </div>
        </va-collapse>
      </va-accordion>
      <contact-group-class />
      <router-link :to="{name: 'all-group-classes'}" class="all-group-classes">
        <va-button>
          View all group classes
        </va-button>
      </router-link>
    </va-card>
  </div>
</template>

<script>
import BasicMannersClasses from '../sub-components/BasicMannersClasses'
import ContactGroupClass from '../sub-components/ContactGroupClass'

export default {
  name: 'basic-manners-card',
  components: {
    BasicMannersClasses,
    ContactGroupClass,
  },
}
</script>

<style scoped lang="scss">
.basic-manners-card {
  .va-card__body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .class-description {
      text-align: left;
      margin: 1rem;
    }

    .va-button {
      border-radius: 0.375rem;
      max-width: 90%;
      width: 90%;
      margin-left: 1rem;

      &__content {
        font-size: 1.3rem;
        font-family: Montserrat, sans-serif;

        &__title {
          font-size: 1.3rem;
        }
      }
    }

    .all-group-classes {
      display: flex;
      justify-content: center;
      margin-top: 1rem;

      .va-button {
        border-radius: 0.375rem;
        max-width: 90%;
        width: 90%;
        margin-left: 1rem;

        @include media-breakpoint-up(lg) {
          width: 50%;
        }

        &__content {
          font-size: 1.3rem;
          font-family: Montserrat, sans-serif;

          &__title {
            font-size: 1.3rem;
          }
        }
      }
    }

    .week-description {
      div {
        margin-top: 1rem;
      }

      ol {
        margin-left: 2rem;

        li {
          list-style: decimal;
        }
      }
    }

    span {
      margin-top: 1rem;
      text-align: center;
    }
  }

  .curriculum,
  .va-accordion {
    width: 100%;
  }
}
</style>
